import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9ce73870&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=9ce73870&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ce73870",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\G\\YT\\mes-project-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ce73870')) {
      api.createRecord('9ce73870', component.options)
    } else {
      api.reload('9ce73870', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=9ce73870&scoped=true", function () {
      api.rerender('9ce73870', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SimpleFlow/src/index.vue"
export default component.exports